import PromoImageWeeklyDemo from "./images/promo-card-live-weekly-demo.png";
import PromoImagePlatform from "./images/promo-card-platform.png";
import AdHoc from "./images/icon-ad-hoc.png";
import AdvancedAnalytics from "./images/icon-advanced-analytics.png";
import DataApps from "./images/icon-custom-data-app.png";
import InteractiveDash from "./images/icon-interactive-dash.png";
import SelfServe from "./images/icon-self-serve.png";
import Resource from "./images/icon-resource.svg";
import Blog from "./images/icon-blog.svg";
import Learn from "./images/icon-learn.svg";

export default {
  buttons: [
    {
      label: "Sign in",
      type: "secondary",
      url: "https://app.mode.com/signin"
    },
    {
      label: "Try for free",
      type: "primary",
      // url: "https://app.mode.com/signup/",
      url: "#",
      formModal: {
        id: "mode-form-signup-header",
        embedContext: "page",
        embedStyle: { "maxWidth": "100%", "width": "380px" },
        strings: { "button_text": "Continue" },
        hubspotSettings: {
          formId: "b47a6f34-c975-49e7-909d-a89d32ec2b81",
          portalId: "48484667",
          name: "Trial",
          redirectUrl: "https://thoughtspot.com/trial/thank-you"
        },
        modeSignupForm: true,
        formValidationSettings: { "email": ["role_blacklist"] }
      }
    },
    {
      label: "Request demo",
      type: "primary",
      calendly: true,
      hidden: true
    }
  ],
  links: [
    {
      type: "dropdownLink",
      label: "Modern BI",
      lists: [
        {
          type: "linkList",
          links: [
            {
              type: "navBlock",
              heading: "Ad Hoc Analysis",
              icon: {
                type: "image",
                asset: AdHoc
              },
              primaryLink: [
                {
                  type: "internalLink",
                  url: "https://mode.com/ad-hoc-analysis/"
                }
              ],
              subheading:
                "Answer challenging and important questions with standalone reports"
            },
            {
              type: "navBlock",
              heading: "Advanced Analytics",
              icon: {
                type: "image",
                asset: AdvancedAnalytics
              },
              primaryLink: [
                {
                  type: "internalLink",
                  url: "https://mode.com/advanced-analytics/"
                }
              ],
              subheading:
                "Analyze and model on the same platform as your charts and dashboards"
            },
            {
              type: "navBlock",
              heading: "Self-Serve Reporting",
              icon: {
                type: "image",
                asset: SelfServe
              },
              primaryLink: [
                {
                  type: "internalLink",
                  url: "https://mode.com/self-serve-reporting/"
                }
              ],
              subheading:
                "Build your own modern reporting, backed up by governed datasets and metrics"
            },
            {
              type: "navBlock",
              heading: "Custom Data Apps",
              icon: {
                type: "image",
                asset: DataApps
              },
              primaryLink: [
                {
                  type: "internalLink",
                  url: "https://mode.com/custom-data-apps/"
                }
              ],
              subheading:
                "Build custom internal tools for thousands of data and business team needs"
            },
            {
              type: "navBlock",
              heading: "Interactive Dashboards",
              icon: {
                type: "image",
                asset: InteractiveDash
              },
              primaryLink: [
                {
                  type: "internalLink",
                  url: "https://mode.com/interactive-dashboards/"
                }
              ],
              subheading:
                "Share the insights you find through drag-and-drop visual analytics tools"
            }
          ]
        },
        {
          type: "linkList",
          heading: "Features",
          links: [
            {
              type: "externalLink",
              label: "SQL Editor",
              url: "https://mode.com/online-sql-editor/"
            },
            {
              type: "externalLink",
              label: "Integrated Notebooks",
              url: "https://mode.com/notebooks/"
            },
            {
              type: "externalLink",
              label: "Visual Explorer",
              url: "https://mode.com/visual-explorer/"
            },
            {
              type: "externalLink",
              label: "Reports \u0026 Dashboards",
              url: "https://mode.com/reports-and-dashboards/"
            },
            {
              type: "externalLink",
              label: "Datasets",
              url: "https://mode.com/datasets/"
            },
            {
              type: "externalLink",
              label: "AI Assist",
              url: "https://mode.com/content/mode-webinar-ai-assist"
            },
            {
              type: "externalLink",
              label: "Security",
              url: "https://mode.com/security/"
            },
            {
              type: "externalLink",
              label: "Integrations",
              url: "https://mode.com/data-sources/"
            }
          ]
        }
      ],
      promoHeading: "Mode is the intelligence layer for your data stack",
      promoImage: {
        type: "image",
        asset: PromoImagePlatform
      },
      promoLink: [
        {
          type: "internalLink",
          label: "Platform overview",
          url: "https://mode.com/platform/"
        }
      ],
      secondaryPromoLink: [
        {
          type: "internalLink",
          label: "Product tour",
          url: "https://mode.com/product-tour/"
        }
      ],
      title: "Modern Business Intelligence"
    },
    {
      type: "internalLink",
      label: "Why Mode",
      url: "https://mode.com/comparisons/"
    },
    {
      type: "internalLink",
      label: "Customer Stories",
      url: "https://mode.com/customers/"
    },
    {
      type: "externalLink",
      label: "Compare Plans",
      url: "https://mode.com/compare-plans/"
    },
    {
      type: "dropdownLink",
      label: "Resources",
      lists: [
        {
          type: "linkList",
          links: [
            {
              type: "navBlock",
              heading: "Resource Center",
              icon: {
                type: "image",
                asset: Resource
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Resource Center",
                  url: "https://mode.com/resources/"
                }
              ],
              subLinks: [
                {
                  type: "externalLink",
                  label: "Modern BI Tool Kit",
                  url: "https://mode.com/toolkits/modern-business-intelligence/"
                },
                {
                  type: "externalLink",
                  label: "Help Center",
                  url: "https://mode.com/help/"
                },
                {
                  type: "externalLink",
                  label: "Developer Hub",
                  url: "https://mode.com/developer/api-reference/introduction/"
                },
                {
                  type: "externalLink",
                  label: "Mode University",
                  url: "https://university.mode.com/"
                }
              ],
              subheading: "The data scientist toolbox"
            },
            {
              type: "navBlock",
              heading: "Our Blog",
              icon: {
                type: "image",
                asset: Blog
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Our Blog",
                  url: "https://mode.com/blog/"
                }
              ],
              subLinks: [
                {
                  type: "externalLink",
                  label: "Analysis",
                  url: "https://mode.com/blog/category/analysis/"
                },
                {
                  type: "externalLink",
                  label: "News and Updates",
                  url: "https://mode.com/blog/category/general/"
                },
                {
                  type: "externalLink",
                  label: "Visualization",
                  url: "https://mode.com/blog/category/visualization/"
                }
              ],
              subheading: "Data insights for everyone"
            },
            {
              type: "navBlock",
              heading: "Learn SQL",
              icon: {
                type: "image",
                asset: Learn
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Learn SQL",
                  url: "https://mode.com/sql-tutorial/"
                }
              ],
              subheading: "Answer data questions with SQL",
              subLinks: [
                {
                  type: "externalLink",
                  label: "The SQL Tutorial For Data Analysis",
                  url: "https://mode.com/sql-tutorial/introduction-to-sql/"
                },
                {
                  type: "externalLink",
                  label: "Using SQL in Mode",
                  url: "https://mode.com/sql-tutorial/sql-in-mode/"
                },
                {
                  type: "externalLink",
                  label: "Putting it together",
                  url:
                    "https://mode.com/sql-tutorial/intro-to-intermediate-sql/"
                }
              ]
            },
            {
              type: "navBlock",
              heading: "Learn Python",
              icon: {
                type: "image",
                asset: Learn
              },
              primaryLink: [
                {
                  type: "externalLink",
                  label: "Learn Python",
                  url: "https://mode.com/python-tutorial/"
                }
              ],
              subheading: "Analyze business data with Python",
              subLinks: [
                {
                  type: "externalLink",
                  label: "Python Basics",
                  url: "https://mode.com/python-tutorial/python-basics/"
                },
                {
                  type: "externalLink",
                  label: "Python Methods, Functions, \u0026 Libraries",
                  url:
                    "https://mode.com/python-tutorial/python-methods-functions-and-libraries/"
                }
              ]
            }
          ]
        }
      ],
      promoEyebrow: "Live demo",
      promoHeading: "Get a firsthand look at Mode's key features & workflows",
      promoImage: {
        type: "image",
        asset: PromoImageWeeklyDemo
      },
      promoLink: [
        {
          type: "externalLink",
          label: "Save your seat",
          url:
            "https://events.mode.com/meet-mode"
        }
      ],
      title: "Resources"
    }
  ]
};
